/** True while the first fetch is in flight — false when cached data is already available. */
export function showQueryLoader(query: { isLoading: boolean; data: unknown }): boolean {
  return query.isLoading && query.data == null;
}
